module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image5-09e9a29e3578a68ad023a95d0cd2ea85.png";